import { createSlice } from '@reduxjs/toolkit';
import { IModal } from '../../../core/components/modals/IModal';
import { ModalReducer } from '../../reducers/ModalReducer';

const initialState: IModal = {
	isOpen: false,
	component: null,
	closable: true,
	position: 'center',
	width: 50,
	version: 'v1',
	isDisabledTertiaryAction: false,
};

export const modalSlice = createSlice({
	name: 'modal',
	initialState,
	reducers: ModalReducer,
});

export const {
	toggleModal,
	secondaryActionTrigger,
	primaryActionTrigger,
	tertiaryActionTrigger,
	updatePrimaryActionText,
	setIsDisabledConfirmAction,
	setIsDisabledTertiaryAction,
	setAdditionalFooterContent,
} = modalSlice.actions;

export default modalSlice.reducer;
